import { areIntervalsOverlapping } from 'date-fns';

/**
 * Will return true if any of the given date ranges overlap one another
 * @param values - Array of date ranges
 */
export const checkForOverlappingDateRanges = (values: { from: Date; to: Date }[]) => {
  return !!values.find(value => {
    const otherValues = values.filter(v => v !== value);
    return otherValues.find(otherValue => {
      return areIntervalsOverlapping(
        { start: value.from, end: value.to },
        { start: otherValue.from, end: otherValue.to },
        { inclusive: true }
      );
    });
  });
};
